/**
 * WARN: русские label — fallback истории. В модалке EN/RU берётся из
 * `history.fields.Taxes.<field>` (затем `history.fields.common.<field>`).
 * При добавлении или изменении подписи обновляйте обе локали.
 */
export const taxesFields = {
  // label — fallback; EN/RU из history.fields.Taxes.*
  submission: { label: 'Submission', valueType: 'relation' },
  product: { label: 'Препарат', valueType: 'relation' },
  product_label: { label: 'Препарат' },
  activity: { label: 'Активность', valueType: 'relation' },
  activity_label: { label: 'Активность' },
  amount: { label: 'Сумма' },
  amount_manual: { label: 'Сумма (ручной ввод)' },
  initiator: { label: 'Инициатор', valueType: 'relation' },
  po_number: { label: 'PO номер' },
  status: { label: 'Статус', valueType: 'relation' },
  tax_number: { label: 'Tax №' },
  tax_date: { label: 'Tax date', valueType: 'date' },
  planned_submission_date: { label: 'Планируемая дата использования', valueType: 'date' },
  service_note_date: { label: 'Service note', valueType: 'date' },
  actual_execution_date: { label: 'Актуальная дата исполнения', valueType: 'date' },
  doc_num: { label: 'Номер документа' },
  doc_date: { label: 'Дата документа', valueType: 'date' },
  refund: { label: 'Возврат' },
  comment: { label: 'Комментарий' },
  auto_created: { label: 'Автоматически создана', valueType: 'bool' },
}

